import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { formAPIPageable } from '../../../../../utils/StringUtils';

export const POST_PAYMENT_REPORT_EXPORT_EXCEL = `/payment-histories/export`;
export const POST_PAYMENT_REPORT_SEARCH = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `/payment-histories/search${tparams}`;
};
export const GET_REPORTING_ORGANISATIONS = `/reporting/organisations`;
export const GET_TRANSACTION_TYPES = `/transaction-types`;
export const GET_EXAM_LEVELS = (functionName: string) => `/exam-levels/${functionName}`;
export const GET_CHECK_ELIGIBILITY = `/payment-histories/check-eligibility`;
export const GET_PAYMENT_STATUSES = `/payment-statuses`;
